import {flattenCustomResolutionResults} from 'notebook/tables/string-resolution/flattenCustomResolutionResults';
import {ServerResolutionResult} from 'notebook/tables/string-resolution/StringResolutionConstants';
import * as net from 'util/Net';

export function doSnapshotFieldPreviewLookupQuery(
  snapshotFieldId: string,
  fileId: string | null,
  lookupInputIds: Array<Array<string>>,
  gridPositionInputValues: Array<string | null | undefined>
): Promise<{serverResolutionResults: Array<ServerResolutionResult>}> {
  const results: Promise<{serverResolutionResults: Array<ServerResolutionResult>}> = net.postJSONPromise({
    url: '/1/api/eln:bulk-perform-snapshot-field-preview-lookups',
    data: {snapshotFieldId, fileId, lookupInputIds, gridPositionInputValues},
  });
  return results.then((value) => ({
    serverResolutionResults: flattenCustomResolutionResults(value.serverResolutionResults, {
      // We want to preserve duplicate values for Selectors since the actual Snapshot Field will resolve to
      // have multiple when actually saved.
      preserveDuplicates: true,
    }),
  }));
}
